import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vue-tl-tlbs-offer-renewal-pif-component" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "pullout" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Reduced from $12,000 to $10,000 for 12 months.")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "We are nearly at the end of the Australian financial year and we have an offer for those of you who might want to prepay your tuition for the next 12 months. Even if you're not in Australia, this offer is open to all students."),
  /*#__PURE__*/_createElementVNode("p", null, "Please review the below commitment agreement, and proceed with payment authorisation at the bottom of the page. This offer expires June 30th 5pm AEST.")
], -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "This end of financial year renewal offer is valid for existing The School students only, and valid through to June 30th, 5pm AEST."),
  /*#__PURE__*/_createElementVNode("li", null, "The discounted fee of $10,000 (AUD plus GST for AU residents) covers 12 months of The School tuition."),
  /*#__PURE__*/_createElementVNode("li", null, "Monthly or annual enrolment cannot be deferred or suspended."),
  /*#__PURE__*/_createElementVNode("li", null, "All fees are non-refundable, non-transferable, and cannot be used as credit or to redeem other services or events.")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeroImageComponent = _resolveComponent("HeroImageComponent")!
  const _component_TlbsCommitmentAgreementComponent = _resolveComponent("TlbsCommitmentAgreementComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeroImageComponent, {
      "sub-title": "The School",
      title: "EOFY Renewal Offer"
    }),
    _hoisted_2,
    _createVNode(_component_TlbsCommitmentAgreementComponent, {
      "is-renewal": true,
      "plan-ids": [_ctx.ChargebeePlanIdEnum.PayInFull10kOffer, _ctx.ChargebeePlanIdEnum.PartPay10kOffer],
      "renewal-type": _ctx.TlbsRenewalTypeEnum.Eofy
    }, {
      "slot-cancellation": _withCtx(() => [
        _hoisted_3
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["plan-ids", "renewal-type"])
  ]))
}